import React, { Component } from 'react'
import { observer } from 'mobx-react'

import Input from '../../form/Input'
import LicenceProduct from './LicenceProduct'
import Anchor from '../../../UniformComponents/Anchor'

@observer
class ProductTypeLicence extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showProducts: false,
        }
    }

    updateLicence = async ({ value }) => {
        const { licenceManagerStore, licence, industry } = this.props
        const { store, getProductTypeLabel, clientId } = licenceManagerStore
        const { licenceCount, productType } = licence

        const label = getProductTypeLabel(industry, productType)

        const newLicenceCount = parseInt(value, 10)

        if (newLicenceCount === licenceCount) return

        if (!this.validateCount({ value: newLicenceCount })) {
            store.handleError({
                body: 'You cannot set licence count to be lower than number of existing licences',
                level: 'error',
            })
            return
        }

        try {
            licence.licenceCount = newLicenceCount
            await licenceManagerStore.saveLicence(licence)
            store.addNotification({
                body: `${label} [${industry}] licence updated for client ${clientId}`,
                level: 'success',
            })
        } catch (e) {
            console.error(e)
            store.handleError({ body: `Error updating licence for client ${clientId}`, level: 'error' })
            licence.licenceCount = licenceCount
        }
    }

    toggleProducts = () => {
        const { showProducts } = this.state

        this.setState({
            showProducts: !showProducts,
        })
    }

    validateCount = ({ value }) => {
        const { licence } = this.props
        const { products } = licence
        const newLicenceCount = parseInt(value, 10)
        const isValid = this.remainingLicences(newLicenceCount, products) >= 0

        return isValid
    }

    remainingLicences = (licenceCount, products) => (
        licenceCount - products.filter(({ status }) => status <= 2).length
    )

    render() {
        const { showProducts } = this.state
        const { licenceManagerStore, licence, industry } = this.props
        const { getProductTypeLabel } = licenceManagerStore
        const { licenceCount, productType, products } = licence
        return (
            <li className="productType">
                <div style={{ display: 'inline-flex' }}>
                    <Input
                        defaultValue={licenceCount}
                        validate={this.validateCount}
                        onBlur={this.updateLicence}
                    />
                    <span className="licencesLeft">
                        {`[${this.remainingLicences(licenceCount, products)}]`}
                    </span>
                    <Anchor
                        onClick={this.toggleProducts}
                    >
                        {getProductTypeLabel(industry, productType)}
                    </Anchor>
                </div>
                {showProducts && (
                    <ul className="productList">
                        {products.map((p) => (
                            <LicenceProduct
                                product={p}
                                licenceManagerStore={licenceManagerStore}
                            />
                        ))}
                    </ul>
                )}
            </li>
        )
    }
}

export default ProductTypeLicence
